<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Contas a pagar</h1>
            <p class="welcome-message">Gerenciamento de obrigações e fornecedores</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          @if (selection.hasValue()) {
          <span>Ações ({{ selection.selected.length }})</span>
          } @else {
          <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #opcoesMenu="matMenu">
          @if (selection.hasValue()) {
          <button mat-menu-item (click)="abrirPagamento(selection.selected)" [disabled]="!isAllSelectedPagavel()"
            [matTooltip]="tooltipBulkPagar()" [matTooltipDisabled]="isAllSelectedPagavel()">
            <mat-icon class="material-symbols-outlined">payments</mat-icon>
            <span>Pagar</span>
          </button>
          <button mat-menu-item (click)="alterarFormaPagamento()" [disabled]="!isAllSelectedEditavel()"
            [matTooltip]="tooltipBulkEditar()" [matTooltipDisabled]="isAllSelectedEditavel()">
            <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
            <span>Alterar forma de pagamento</span>
          </button>
          <button mat-menu-item (click)="alterarTagsEmMassa()">
            <mat-icon class="material-symbols-outlined">label</mat-icon>
            <span>Alterar tags</span>
          </button>
          <button mat-menu-item (click)="alterarCategoriaEmMassa()" [disabled]="!isAllSelectedEditavel()"
            [matTooltip]="tooltipBulkEditar()" [matTooltipDisabled]="isAllSelectedEditavel()">
            <mat-icon class="material-symbols-outlined">category</mat-icon>
            <span>Alterar categoria</span>
          </button>
          <button mat-menu-item (click)="editarEmMassa()" [disabled]="!isAllSelectedEditavel()"
            [matTooltip]="tooltipBulkEditar()" [matTooltipDisabled]="isAllSelectedEditavel()">
            <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
            <span>Edição em Massa</span>
          </button>
          <button mat-menu-item (click)="agruparContas()" [disabled]="!isAllSelectedAgrupavel()"
            [matTooltip]="tooltipBulkAgrupar()" [matTooltipDisabled]="isAllSelectedAgrupavel()">
            <mat-icon class="material-symbols-outlined">merge</mat-icon>
            <span>Agrupar contas / Renegociar</span>
          </button>
          <button mat-menu-item (click)="cancelarContas()" [disabled]="!isAllSelectedCancelavel()"
            [matTooltip]="tooltipBulkCancelar()" [matTooltipDisabled]="isAllSelectedCancelavel()">
            <mat-icon class="material-symbols-outlined">cancel</mat-icon>
            <span>Cancelar contas</span>
          </button>
          <button mat-menu-item (click)="excluirContas()" [disabled]="!isAllSelectedExcluivel()"
            [matTooltip]="tooltipBulkExcluir()" [matTooltipDisabled]="isAllSelectedExcluivel()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            <span>Excluir selecionados</span>
          </button>
          } @else {
          <button mat-menu-item (click)="abrirImpressao()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir</span>
          </button>
          <button mat-menu-item (click)="exportarContasPagar()">
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar lançamentos para planilha</span>
          </button>
          <button mat-menu-item (click)="abrirImportacao()">
            <mat-icon class="material-symbols-outlined">file_download</mat-icon>
            <span>Importar lançamentos de uma planilha</span>
          </button>
          }
        </mat-menu>

        <button type="button" mat-flat-button class="btn-primary" routerLink="/financas/contas-pagar/cadastrar">
          <span class="material-symbols-outlined">add</span>
          Nova conta a pagar
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa"
              placeholder="Pesquise por histórico ou nº documento" />

            <button mat-icon-button matSuffix [matMenuTriggerFor]="refinarMenu" type="button" aria-label="Refinar Busca"
              matTooltip="Refinar busca">
              <mat-icon>tune</mat-icon>
            </button>
            <mat-menu #refinarMenu="matMenu">
              <button mat-menu-item (click)="filtroRefinar = null">
                @if (filtroRefinar === null) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== null">Não refinar</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.NumeroDocumento">
                @if (filtroRefinar === _refinamentoEnum.NumeroDocumento) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.NumeroDocumento">Nº documento</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.Historico">
                @if (filtroRefinar === _refinamentoEnum.Historico) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.Historico">Histórico</span>
              </button>
            </mat-menu>

            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-8 mb-3 mb-md-0 d-flex flex-wrap gap-3">
          <!-- Seletor de Periodo -->
          <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-periodo"
            [matMenuTriggerFor]="periodoMenu" (menuOpened)="prepararPeriodoIntervalo()" [class.btn-periodo--ativo]="
              periodoSelecionado !== PeriodoContasPagarEnum.DoMes && periodoSelecionado !== undefined
            ">
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
            <div class="periodo-menu-content">
              <div>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasPagarEnum.Hoje); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoContasPagarEnum.Hoje">
                  <span>hoje</span>
                  @if (periodoSelecionado === PeriodoContasPagarEnum.Hoje) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasPagarEnum.DaSemana); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoContasPagarEnum.DaSemana">
                  <span>desta semana</span>
                  @if (periodoSelecionado === PeriodoContasPagarEnum.DaSemana) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasPagarEnum.DoMes); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoContasPagarEnum.DoMes">
                  <span>do mês</span>
                  @if (periodoSelecionado === PeriodoContasPagarEnum.DoMes) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasPagarEnum.Ultimos30Dias); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="
                    periodoSelecionado === PeriodoContasPagarEnum.Ultimos30Dias
                  ">
                  <span>últimos 30 dias</span>
                  @if (periodoSelecionado === PeriodoContasPagarEnum.Ultimos30Dias) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasPagarEnum.DoIntervalo); $event.stopPropagation()"
                  [class.periodo-item-selecionado]="
                    periodoSelecionado === PeriodoContasPagarEnum.DoIntervalo
                  ">
                  <span>do intervalo</span>
                  @if (periodoSelecionado === PeriodoContasPagarEnum.DoIntervalo) {
                  <mat-icon>check</mat-icon>
                  }
                </button>

                @if (periodoSelecionado === PeriodoContasPagarEnum.DoIntervalo) {
                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <mat-label>De</mat-label>
                    <input matInput [matDatepicker]="pickerPeriodoDe" placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataDe')" formControlName="dataDe" />
                    <mat-datepicker-toggle matSuffix [for]="pickerPeriodoDe"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPeriodoDe></mat-datepicker>
                    @if (model.get('dataDe')?.hasError('required')) {
                    <mat-error>Data inicial obrigatória</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Até</mat-label>
                    <input matInput [matDatepicker]="pickerPeriodoAte" placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataAte')" formControlName="dataAte" />
                    <mat-datepicker-toggle matSuffix [for]="pickerPeriodoAte"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPeriodoAte></mat-datepicker>
                    @if (model.get('dataAte')?.hasError('required')) {
                    <mat-error>Data final obrigatória</mat-error>
                    }
                    @if (model.get('dataAte')?.hasError('dataInvalida')) {
                    <mat-error>Data final menor que inicial</mat-error>
                    }
                    @if (model.get('dataAte')?.hasError('intervaloExcedido')) {
                    <mat-error>Intervalo máx. de {{ limiteMeses }} meses</mat-error>
                    }
                  </mat-form-field>

                  <div class="periodo-intervalo-actions">
                    <button type="button" mat-button class="btn-secondary"
                      (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                      Cancelar
                    </button>
                    <button type="button" mat-flat-button class="btn-primary"
                      (click)="aplicarPeriodo(periodoMenuTrigger)">
                      Aplicar
                    </button>
                  </div>
                </div>
                }
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>

                <div class="filter-menu__form">
                  <!-- Fornecedor -->
                  <app-select-pesquisavel label="Fornecedor" [control]="$any(model.get('listaIdFornecedor'))"
                    [apiUrl]="urlFornecedor" idField="id" nameField="descricao" [multiple]="true" [isOptional]="true"
                    hint="Todos">
                  </app-select-pesquisavel>

                  <!-- Situação -->
                  <app-select-pesquisavel label="Situação do pagamento" [control]="$any(model.get('idStatus'))"
                    [idField]="'idStatusContasPagar'" [nameField]="'descricao'" [offlineList]="listaStatus"
                    [isOptional]="true" hint="Todas">
                  </app-select-pesquisavel>

                  <!-- Categoria -->
                  <app-select-pesquisavel label="Categoria" [control]="$any(model.get('idCategoria'))"
                    [idField]="'idCategoriaFinanceira'" [nameField]="'descricao'" [offlineList]="listaCategoria"
                    [isOptional]="true" hint="Selecionar Categoria">
                  </app-select-pesquisavel>

                  <!-- Forma de Pagamento -->
                  <app-select-pesquisavel label="Forma de pagamento" [control]="$any(model.get('idFormaPagamento'))"
                    [idField]="'idFormaPagamento'" [nameField]="'descricao'" [offlineList]="listaFormaPagamento"
                    [isOptional]="true" hint="Todas">
                  </app-select-pesquisavel>

                  <!-- Tags -->
                  <app-select-pesquisavel label="Tags" [control]="$any(model.get('tags'))"
                    [idField]="'idTagContasPagar'" [nameField]="'descricao'" [offlineList]="listaTags" [multiple]="true"
                    [isOptional]="true" hint="Selecione tags">
                  </app-select-pesquisavel>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>

          <button mat-stroked-button type="button" class="btn-filter desktop-view" (click)="configurarColunas()">
            <mat-icon>view_column</mat-icon>
            Configurar Colunas
          </button>
        </div>
      </div>
    </form>

    @if (_response && _dataSource.data.length > 0) {
    <div class="table-container desktop-view">
      <table mat-table [dataSource]="_dataSource" matSort>
        <!-- Checkbox -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="w-checkbox">
            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
              [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="w-checkbox">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Fornecedor -->
        <ng-container matColumnDef="fornecedor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fornecedor</th>
          <td mat-cell *matCellDef="let row">{{ row.fornecedor || '-' }}</td>
        </ng-container>

        <!-- Nome Fantasia -->
        <ng-container matColumnDef="nomeFantasia">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome Fantasia</th>
          <td mat-cell *matCellDef="let row">{{ row.nomeFantasia || '-' }}</td>
        </ng-container>

        <!-- Descrição -->
        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
          <td mat-cell *matCellDef="let row">
            <div class="descricao-cell" [matTooltip]="
                row.isParcelado
                  ? 'Parcela ' + (row.nroParcela || 1) + ' de ' + (row.qtdParcelas || row.nroParcela || 1)
                  : row.isRecorrente
                    ? 'Recorrente'
                    : ''
              " [matTooltipDisabled]="!row.isParcelado && !row.isRecorrente">
              @if (row.isRecorrente) {
              <mat-icon class="tipo-lancamento-icon">autorenew</mat-icon>
              } @else if (row.isParcelado) {
              <mat-icon class="tipo-lancamento-icon">content_copy</mat-icon>
              }
              <span class="text-truncate">{{ row.descricao || '-' }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Nº Documento -->
        <ng-container matColumnDef="numeroDocumento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº documento</th>
          <td mat-cell *matCellDef="let row">{{ row.numeroDocumento || '-' }}</td>
        </ng-container>

        <!-- Categoria -->
        <ng-container matColumnDef="categoria">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Categoria</th>
          <td mat-cell *matCellDef="let row">{{ row.categoria || '-' }}</td>
        </ng-container>

        <!-- Forma de Pagamento -->
        <ng-container matColumnDef="formaPagamento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Forma de Pagamento</th>
          <td mat-cell *matCellDef="let row">{{ row.formaPagamento || '-' }}</td>
        </ng-container>

        <!-- Valor -->
        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor</th>
          <td mat-cell *matCellDef="let row">{{ row.valor | abnt: 'preco': 2 }}</td>
        </ng-container>

        <!-- Pago -->
        <ng-container matColumnDef="pago">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Pago</th>
          <td mat-cell *matCellDef="let row">{{ row.pago | abnt: 'preco': 2 }}</td>
        </ng-container>

        <!-- A Pagar -->
        <ng-container matColumnDef="aPagar">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>A pagar</th>
          <td mat-cell *matCellDef="let row">{{ row.aPagar | abnt: 'preco': 2 }}</td>
        </ng-container>

        <!-- Vencimento -->
        <ng-container matColumnDef="vencimento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Vencimento</th>
          <td mat-cell *matCellDef="let row">{{ row.vencimento | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <!-- Tags -->
        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tags</th>
          <td mat-cell *matCellDef="let row">
            <div class="tags-cell">
              @for (tag of row.tags; track tag.id) {
              <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
              }
            </div>
          </td>
        </ng-container>

        <!-- Situação -->
        <ng-container matColumnDef="situacao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge" [ngClass]="getSituacaoClass(row.idStatus)">
              {{ row.situacao }}
            </span>
          </td>
        </ng-container>

        <!-- Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
          <td mat-cell *matCellDef="let row" class="text-center">
            <button mat-icon-button class="icon-mat-symbols-btn" [matMenuTriggerFor]="menuRow" aria-label="Ações"
              (click)="$event.stopPropagation()">
              <span class="material-symbols-outlined">more_horiz</span>
            </button>
            <mat-menu #menuRow="matMenu">
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipPagar(row)"
                [matTooltipDisabled]="!tooltipPagar(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="abrirPagamento([row])" [disabled]="
                    row.idStatus === _StatusContasPagarEnum.Cancelada ||
                    row.idStatus === _StatusContasPagarEnum.Pago
                  ">
                  <span class="material-symbols-outlined">payments</span>
                  <span>Pagar</span>
                </button>
              </span>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipEstorno(row)"
                [matTooltipDisabled]="!tooltipEstorno(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="estornarPagamento(row)" [disabled]="
                    row.idStatus !== _StatusContasPagarEnum.Pago &&
                    row.idStatus !== _StatusContasPagarEnum.PagoParcialmente &&
                    row.pago <= 0
                  ">
                  <span class="material-symbols-outlined">undo</span>
                  <span>Estornar Pagamento</span>
                </button>
              </span>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipEditar(row)"
                [matTooltipDisabled]="isEditavel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="alterarFormaPagamento([row])" [disabled]="!isEditavel(row)">
                  <span class="material-symbols-outlined">swap_horiz</span>
                  <span>Alterar forma de pagamento</span>
                </button>
              </span>
              <button mat-menu-item (click)="alterarTagsEmMassa([row])">
                <span class="material-symbols-outlined">label</span>
                <span>Alterar tags</span>
              </button>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipEditar(row)"
                [matTooltipDisabled]="isEditavel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="alterarCategoriaEmMassa([row])" [disabled]="!isEditavel(row)">
                  <span class="material-symbols-outlined">category</span>
                  <span>Alterar categoria</span>
                </button>
              </span>
              @if (row.isParcelado) {
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipEditar(row)"
                [matTooltipDisabled]="isEditavel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item [routerLink]="['/financas/contas-pagar/parcela', row.idContasPagarParcela]"
                  [disabled]="!isEditavel(row)">
                  <span class="material-symbols-outlined">edit</span>
                  <span>Editar Parcela</span>
                </button>
              </span>
              }
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipEditar(row)"
                [matTooltipDisabled]="isEditavel(row) || row.isAgrupado" [matTooltipPosition]="'above'">
                <button mat-menu-item
                  [routerLink]="['/financas/contas-pagar/cadastrar', { idContasPagar: row.idContasPagar }]"
                  [disabled]="!isEditavel(row) && !row.isAgrupado">
                  <span class="material-symbols-outlined">edit</span>
                  <span>Editar Lançamento</span>
                </button>
              </span>
              @if (row.isAgrupado) {
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipDesagrupar(row)"
                [matTooltipDisabled]="isDesagrupavel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="desagrupar(row)" [disabled]="!isDesagrupavel(row)">
                  <span class="material-symbols-outlined">call_split</span>
                  <span>Desagrupar</span>
                </button>
              </span>
              }
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipCancelar(row)"
                [matTooltipDisabled]="isCancelavel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="cancelarContas([row])" [disabled]="!isCancelavel(row)">
                  <span class="material-symbols-outlined">cancel</span>
                  <span>Cancelar</span>
                </button>
              </span>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipExcluir(row)"
                [matTooltipDisabled]="isExcluivel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="excluirContas([row])" [disabled]="!isExcluivel(row)">
                  <span class="material-symbols-outlined">delete</span>
                  <span>Excluir</span>
                </button>
              </span>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <!-- Mobile View -->
    <div class="mobile-view">
      @for (item of _dataSource.data; track item.idContasPagarParcela) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)"
              color="primary">
            </mat-checkbox>
            <div class="d-flex flex-column">
              <span class="text-bold">{{ item.fornecedor || '-' }}</span>
              <small>{{ item.descricao }}</small>
            </div>
          </div>
          <button mat-icon-button class="icon-mat-symbols-btn" [matMenuTriggerFor]="menuMobile">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuMobile="matMenu">
            <button mat-menu-item (click)="abrirPagamento([item])">Pagar</button>
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'" [matTooltip]="
                    item.idStatus !== _StatusContasPagarEnum.Pago &&
                    item.idStatus !== _StatusContasPagarEnum.PagoParcialmente
                      ? 'Apenas parcelas com pagamento completo ou parcial podem ser estornadas'
                      : ''
                  ">
              <button mat-menu-item (click)="estornarPagamento(item)" [disabled]="
                    item.idStatus !== _StatusContasPagarEnum.Pago &&
                    item.idStatus !== _StatusContasPagarEnum.PagoParcialmente
                  ">
                Estornar Pagamento
              </button>
            </span>
            <button mat-menu-item (click)="alterarTagsEmMassa([item])">Alterar tags</button>
            <button mat-menu-item (click)="alterarCategoriaEmMassa([item])">Alterar categoria</button>
            @if (item.isParcelado) {
            <button mat-menu-item [routerLink]="['/financas/contas-pagar/parcela', item.idContasPagarParcela]">
              Editar Parcela
            </button>
            }
            <button mat-menu-item
              [routerLink]="['/financas/contas-pagar/cadastrar', { idContasPagar: item.idContasPagar }]">
              Editar Lançamento
            </button>
            @if (item.isAgrupado) {
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'"
              [matTooltip]="tooltipDesagrupar(item)" [matTooltipDisabled]="isDesagrupavel(item)">
              <button mat-menu-item (click)="desagrupar(item)" [disabled]="!isDesagrupavel(item)">
                Desagrupar
              </button>
            </span>
            }
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'" [matTooltip]="
                    item.idStatus !== _StatusContasPagarEnum.EmAberto ? 'A conta precisa estar Em Aberto' : ''
                  ">
              <button mat-menu-item (click)="cancelarContas([item])"
                [disabled]="item.idStatus !== _StatusContasPagarEnum.EmAberto">
                Cancelar
              </button>
            </span>
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'" [matTooltip]="
                    item.idStatus !== _StatusContasPagarEnum.EmAberto &&
                    item.idStatus !== _StatusContasPagarEnum.Cancelada
                      ? 'A conta precisa estar Em Aberto ou Cancelada'
                      : ''
                  ">
              <button mat-menu-item (click)="excluirContas([item])" [disabled]="
                    item.idStatus !== _StatusContasPagarEnum.EmAberto &&
                    item.idStatus !== _StatusContasPagarEnum.Cancelada
                  ">
                Excluir
              </button>
            </span>
          </mat-menu>
        </div>
        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Valor</small>
              <span class="text-bold">{{ item.valor | abnt: 'preco': 2 }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Vencimento</small>
              <span>{{ item.vencimento | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Situação</small>
              <span class="status-badge" [ngClass]="getSituacaoClass(item.idStatus)">{{
                item.situacao
                }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">A pagar</small>
              <span>{{ item.aPagar | abnt: 'preco': 2 }}</span>
            </div>
            @if (item.tags?.length) {
            <div class="col-12 mb-2">
              <small class="d-block">Tags</small>
              <div class="tags-cell">
                @for (tag of item.tags; track tag.id) {
                <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Ver Mais -->
    <div class="col-12 text-center">
      <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading === true) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>
    } @else if (_isLoading === true && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <app-empty-list [title]="'Nenhum lançamento encontrado'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>

<div class="footer-totals">
<div class="footer-totals-inner">
  <div class="footer-totals-item footer-totals-item--saida">
    <span class="footer-totals-label">Vencidos (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalVencidos | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-item footer-totals-item--alerta">
    <span class="footer-totals-label">Vencem hoje (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalVencemHoje | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-item footer-totals-item--info">
    <span class="footer-totals-label">A vencer (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalAVencer | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-item footer-totals-item--entrada">
    <span class="footer-totals-label">Pagos (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalPagos | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-item footer-totals-item--total">
    <span class="footer-totals-label">Total do período (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalPeriodo | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-count">
    <mat-icon class="material-symbols-outlined">description</mat-icon>
    <span>{{ _quantidadeLancamentos }} Lançamentos</span>
  </div>
  <button mat-icon-button class="icon-mat-symbols-btn" (click)="toggleOcultarValores()"
    matTooltip="Ocultar/Exibir valores">
    <mat-icon class="material-symbols-outlined">{{
      _ocultarValores ? 'visibility_off' : 'visibility'
      }}</mat-icon>
  </button>
</div>
</div>
<div class="footer-totals-height-fake"></div>

<!-- Mobile FAB -->
<button type="button" class="btn-footer-totals-mobile" (click)="toggleGavetaMobile()" aria-label="Abrir resumo financeiro">
  <span class="material-symbols-outlined">analytics</span>
</button>

<!-- Mobile Drawer Backdrop -->
@if (isMobileDrawerOpen) {
<div class="footer-totals-mobile-sheet-backdrop" (click)="fecharGavetaMobile()"></div>
}

<!-- Mobile Drawer -->
<div class="footer-totals-mobile-sheet" [class.open]="isMobileDrawerOpen">
  <div class="footer-totals-mobile-sheet__header modal-header">
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">analytics</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h3 class="modal-title">Resumo Financeiro</h3>
    </div>
    <div class="modal-header-close-btn-container">
      <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="fecharGavetaMobile()" aria-label="Fechar resumo financeiro">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__content">
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--saida">
      <span class="footer-totals-mobile-sheet__label">VENCIDOS (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_totalVencidos | abnt: 'preco': 2)
        }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--alerta">
      <span class="footer-totals-mobile-sheet__label">VENCEM HOJE (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_totalVencemHoje | abnt: 'preco': 2) }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--info">
      <span class="footer-totals-mobile-sheet__label">A VENCER (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_totalAVencer | abnt: 'preco': 2) }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--entrada">
      <span class="footer-totals-mobile-sheet__label">PAGOS (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_totalPagos | abnt: 'preco': 2) }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--total footer-totals-mobile-sheet__item--full">
      <span class="footer-totals-mobile-sheet__label">TOTAL DO PERÍODO (R$)</span>
      <span class="footer-totals-mobile-sheet__value footer-totals-mobile-sheet__total footer-totals-mobile-sheet__total--large">{{ _ocultarValores ? '••••' : (_totalPeriodo | abnt:
        'preco': 2) }}</span>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__footer">
    <span class="footer-totals-count">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      {{ _quantidadeLancamentos }} Lançamentos
    </span>
    <button mat-icon-button type="button" class="icon-mat-symbols-btn" (click)="toggleOcultarValores()"
      [matTooltip]="_ocultarValores ? 'Exibir valores' : 'Ocultar valores'"
      [attr.aria-label]="_ocultarValores ? 'Exibir valores' : 'Ocultar valores'">
      <mat-icon class="material-symbols-outlined">{{ _ocultarValores ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  </div>
</div>
